import React from 'react'
import PropTypes from "prop-types";

class ModalDetalleConfiguraciones extends React.Component {

  state = {
    loading: false,
    datos: null,
  };

  dialogRef = React.createRef();

  componentDidUpdate(prevProps) {
    if (!prevProps.abierto && this.props.abierto) {
      const dialog = this.dialogRef.current;

      if (dialog && typeof dialog.showModal === "function") {
        requestAnimationFrame(() => {
          dialog.showModal();
        });
      }
    }

    if (prevProps.abierto && !this.props.abierto) {
      this.dialogRef.current?.close();
    }
  }

  cargarDetalles = (id) => {

    this.setState({ loading: true, datos: null });

    if (this.props.fetchDetalle == null) {
      this.setState({ datos: id, loading: false });
    } else {
      this.props
        .fetchDetalle(id)
        .then((datos) => {
          this.setState({ datos, loading: false });
        })
        .catch((error) => {
          console.error("Error al cargar los detalles:", error);
          this.setState({ loading: false });
        });
    }
  };

  renderContenido = () => {
    const { loading, datos } = this.state;

    if (loading) return <p>Cargando...</p>;
    if (!datos) return <p>No se pudieron cargar los detalles.</p>;
    return this.props.renderContenido(datos);
  };

  handleCerrar = () => {
    this.dialogRef.current?.close();
    if (this.props.onClose) this.props.onClose();
  };

  render() {
    const { titulo } = this.props;

    return (
      <div className={`component-modal-side`}>
        <dialog
          className="modal"
          id="modal-detalle-documento"
          ref={this.dialogRef}
        >
          <div className="modal-content">
            <div className="modal-head">
              <h4 className="modal-title">{titulo || "Detalles"}</h4>
              <div className="actions">
                <button
                  className="btn-medium btn-circle-icon btn-primary-tonal"
                  id="close-modal"
                  onClick={this.handleCerrar}
                >
                  <span className="material-symbols-outlined">close</span>
                </button>
              </div>
            </div>

            <div className="modal-body">{this.renderContenido()}</div>
          </div>
        </dialog>
      </div>
    );
  }
}

ModalDetalleConfiguraciones.propTypes = {
  abierto: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  titulo: PropTypes.string,
  fetchDetalle: PropTypes.func.isRequired,
  renderContenido: PropTypes.func.isRequired,
  size: PropTypes.oneOf(["sm", "md"]),
};

export default ModalDetalleConfiguraciones;